var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.filterOption),function(item){return _c('li',{key:item.value,class:{active: _vm.selected === item.value},on:{"click":function($event){return _vm.change(item)}}},[_vm._v(" "+_vm._s(item.txt)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }